var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Header from "../../components/Header";
import CollectiveModalityStepper from "../../components/Steppers/CollectiveModalityStepper";
export default function EscolaModalidadeColetivaPage() {
    return (_jsxs("div", __assign({ className: "container px-6 xl:px-24 space-y-9" }, { children: [_jsx(Header, { title: "Jogos Escolares Piauienses 2025", subtitle: "Inscri\u00E7\u00E3o Escola-modalidade" }), _jsx(CollectiveModalityStepper, {})] })));
}
